module.exports = __webpack_public_path__ + "static/media/logo_sisma.8e3d2a99.png";